import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import keycloak from "./keycloak";
import reportWebVitals from "./reportWebVitals";

keycloak
  .init({ onLoad: "check-sso" })
  .then((authenticated) => {
    ReactDOM.render(<App authenticated={authenticated} />, document.getElementById("root"));
  })
  .catch(() => {
    console.error("Authenticated Failed");
  });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
